export default __webpack_public_path__ + "static/media/Ann_Théato_AHV_In_Moms_We_Trust.80c10bdb.jpg";